import { Popover, PopoverArrow, PopoverContent, PopoverTrigger } from "@radix-ui/react-popover";
import clsx from "clsx";
import type { ReactNode } from "react";

interface DateRangePickerPopoverProps {
  open?: boolean;
  onOpenChange?: (value: boolean) => void;
  triggerNode?: ReactNode;
  contentNode?: ReactNode;
}

export function DateRangePickerPopover({ open, onOpenChange, triggerNode, contentNode }: DateRangePickerPopoverProps) {
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>{triggerNode}</PopoverTrigger>
      <PopoverContent asChild align="start" alignOffset={4}>
        <div className={clsx("bg-white", "shadow-elevation-high", "rounded-xl", "min-w-[320px]", "z-20")}>
          <PopoverArrow offset={10} width={16} height={8} className="fill-white" />
          {contentNode}
        </div>
      </PopoverContent>
    </Popover>
  );
}
